import { ref, watch } from '@vue/composition-api'
import {
  useTableComponent, useCommenSettings, useAlert,
} from '@/libs/mixins/index'
import store from '@/store'
// import router from '@/router'

export const usePlaceSetting = () => {
  const {
    syncObject,
    refonlineTime,
    onlineTime,
    updateOnline,
  } = useCommenSettings()

  const ui = {}

  return {
    ui,

    syncObject,
    refonlineTime,
    onlineTime,
    updateOnline,
  }
}

export const usePlaceList = () => {
  const {
    refDataListTable,
    perPage,
    totalNum,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    tableColumns,
    dataMeta,
    refetchData,
  } = useTableComponent()

  const {
    useHttpCodeAlert,
  } = useAlert()

  tableColumns.value = [
    {
      label: '#編號', key: 'id', sortable: true, searchable: false, select: true,
    },
    {
      label: '地點名稱', key: 'name', sortable: true, searchable: true, select: true,
    },
    {
      label: '說明', key: 'description', sortable: true, searchable: true, select: true,
    },
    {
      label: '創建日期', key: 'created_at', sortable: true, searchable: true, select: true,
    },
    {
      label: '動作', key: 'actions', searchable: true, select: true,
    },
  ]

  const isBusy = ref(false)
  const timeRange = ref(null)

  const setPlaceDelete = (...arg) => store.dispatch('admin-place/setPlaceDelete', ...arg)
  const setPlaceCreate = (...arg) => store.dispatch('admin-place/setPlaceCreate', ...arg)
  const setPlaceUpdate = (...arg) => store.dispatch('admin-place/setPlaceUpdate', ...arg)

  const getPlaceListData = (ctx, callback) => {
    // if (store.state.app.ability.user === 'none') {
    //   router.replace({ name: 'admin-home' })
    //   return
    // }

    // 整理timeRange
    // let resolveTimeRange = null
    // if (timeRange.value) {
    //   resolveTimeRange = timeRange.value.split(' 至 ')
    //   const [start, end] = resolveTimeRange
    //   if (end) {
    //     resolveTimeRange = `${start} to ${end}`
    //   } else resolveTimeRange = `${start}`
    // }

    store.dispatch('admin-place/getPlaceList', {
      search: searchQuery.value,
      limit: perPage.value,
      page: currentPage.value,
      sort: sortBy.value,
      order: isSortDirDesc.value ? 'desc' : 'asc',
      offset: dataMeta.value.from,
      // range: resolveTimeRange,
      // filters: resolveFilters,
      _: Date.now(),
    })
      .then(response => {
        const { data, total } = response.data.data
        callback(data)
        totalNum.value = total
      })
      .catch(error => {
        useHttpCodeAlert(error.response)
      })
  }

  const refetchTable = () => {
    if (currentPage.value !== 1) {
      currentPage.value = 1
    } else refetchData()
  }

  watch([currentPage, perPage, searchQuery, timeRange], () => {
    refetchData()
  })

  return {
    isBusy,
    refDataListTable,
    perPage,
    totalNum,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    tableColumns,
    dataMeta,
    timeRange,
    refetchData,
    refetchTable,

    setPlaceDelete,
    setPlaceCreate,
    setPlaceUpdate,
    getPlaceListData,
    useHttpCodeAlert,
  }
}
